import { render } from "./ModalPricing.vue?vue&type=template&id=2975aa16&scoped=true"
import script from "./ModalPricing.vue?vue&type=script&lang=js"
export * from "./ModalPricing.vue?vue&type=script&lang=js"

import "./ModalPricing.vue?vue&type=style&index=0&id=2975aa16&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2975aa16"]])

export default __exports__